import { withStyles } from '@aura/components/styles'
import Button from '@aura/components/button'
import Grid from '@aura/components/grid'
import { useTranslation } from 'react-i18next'
import HorizontalGroup from '@aura/components/horizontal-group'
import Box from '@aura/components/box'
import { Typography } from '@aura/components'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import RegistrationContainerNew from '../../../../components/registration-container-new'
import styles from './styles'


const Component = ({
    classes,
    data,
    isBackAllowed,
    onBack,
    onNext,
    title,
    verbiage
}) => {

    const { t: translate } = useTranslation()

    const { sharedSecret } = data
    const stepTitle = translate('cantScanQRCode')
    const verbiageContainer = <div><Typography className={classes.verbiage}>{translate('cantScanQRCode')}</Typography><Typography className={classes.verbiage}>{translate(`authenticatorOptions.${verbiage}`)}</Typography></div>

    const footerContent = ( 
        <Grid className={classes.buttonContainer} container item md={12} xs={12}>
            <Grid className={clsx(classes.cannotScanContainer, classes.actionRow)} container justify="flex-end">
                <HorizontalGroup gutter={10}>
                    {isBackAllowed
                        ? <Button
                            className={classes.buttonBack}
                            onClick={onBack}
                            variant="text">{translate('back')}
                        </Button>
                        : <></>
                    }
                    <Button
                        className={classes.buttonSubmit}
                        onClick={onNext}
                        variant="contained">{translate('next')}
                    </Button>
                </HorizontalGroup>
            </Grid>
        </Grid>)

    return (
        <RegistrationContainerNew {...{ footerActions: footerContent, title: translate(`authenticatorOptions.${title}`), verbiage: verbiageContainer }}>
            <div className={classes.fieldsContainer}>
                <Grid container className={classes.cantScanContainer} spacing={2}>
                    <Grid item md={12} xs={12}>
                        <Typography className={classes.secretContainer}>{sharedSecret}</Typography>
                    </Grid>
                </Grid>
            </div>
            <Box className={classes.warningLine}>{translate('mfaEnrollment.verbiage07')} </Box>
        </RegistrationContainerNew>
    )
}

Component.displayName = 'QRCodeCannotScan'

Component.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.object,
        loader: PropTypes.object,
        root: PropTypes.object,
        stepper: PropTypes.object,
        stepperContainer: PropTypes.object
    }),
    data: PropTypes.object,
    isBackAllowed: PropTypes.bool,
    onBack: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    verbiage: PropTypes.string
}

export default withStyles(Component, styles)
